import * as React from 'react';
const SvgSearch = (props) => (
  <svg viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#search_svg__a)"
      stroke="#000"
      strokeWidth={3.6}
      strokeMiterlimit={10}
      strokeLinecap="round">
      <path d="M71.588 36.949V68.99M59.633 43.717v25.274M47.679 51.9V68.99M35.724 59.185v9.806M106.682 56.925c-1.442 28.928-26.065 51.206-54.993 49.764C22.77 105.24.49 80.624 1.932 51.696 3.38 22.77 27.997.49 56.925 1.932c28.927 1.442 51.206 26.065 49.764 54.993h-.007Z" />
      <path d="M91.074 56.14c-1.015 20.305-18.296 35.942-38.6 34.927-20.306-1.015-35.942-18.296-34.927-38.6 1.015-20.306 18.296-35.942 38.6-34.927 20.305 1.015 35.942 18.296 34.927 38.6ZM99.557 83.312l19.997 17.428c5.823 5.074 6.131 14.019.665 19.486-5.46 5.459-14.412 5.158-19.486-.665L83.305 99.564" />
    </g>
    <defs>
      <clipPath id="search_svg__a">
        <path fill="#fff" d="M0 0h126v126H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSearch;
